import React, { Component } from 'react'
import {Link} from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fetchArticles} from '../helpers/redux/actions/articlesActions';


export class articles extends Component {
    constructor(props){
        super(props);
        this.state={
            articles:[],
            imgUrl:[],
            author:[],
            isLoaded:false
        }
    }
    setDateDisplay(date){
        let dateVar = new Date(date), monthVar=dateVar.getMonth()+1, fixMonth;
        if(monthVar===1){
            fixMonth = "Januari";
        }else if(monthVar===2){
            fixMonth = "Februari";
        }else if(monthVar===3){
            fixMonth = "Maret";
        }else if(monthVar===4){
            fixMonth = "April";
        }else if(monthVar===5){
            fixMonth = "Mei";
        }else if(monthVar===6){
            fixMonth = "Juni";
        }else if(monthVar===7){
            fixMonth = "Juli";
        }else if(monthVar===8){
            fixMonth = "Agustus";
        }else if(monthVar===9){
            fixMonth = "September";
        }else if(monthVar===10){
            fixMonth = "Oktober";
        }else if(monthVar===11){
            fixMonth = "November";
        }else if(monthVar===12){
            fixMonth = "Desember";
        }
        return fixMonth+" "+dateVar.getDate()+", "+dateVar.getFullYear();
    }

    setLoaded(){
        this.setState({isLoaded:true})
    }

    componentDidUpdate(prevProps){
        console.log("MASUK DID UPDATEE");
        if(prevProps.articles !== this.props.articles){ 
           this.setLoaded();
        }
     }

    componentWillMount(){
        const {articles} = this.props;
        console.log("ARTICLESS = ",articles);
        if (articles === undefined || articles.length === 0) {
            this.props.fetchArticles();
        }else{
            this.setLoaded();
        }
    }

    render() {
        const {isLoaded} = this.state;
        const {articles} = this.props
        const meta = {
            title: 'TITLE FROM ARTICLE',
            description: 'I am a description, and I can create multiple tags',
            canonical: 'http://example.com/path/to/page',
            meta: {
              charset: 'utf-8',
              name: {
                keywords: 'react,meta,document,html,tags'
              }
            }
        };
        if(isLoaded){
            return (
                <DocumentMeta {...meta}>
                    <div className="container">
                        <h1 className="text-center mb-5 mt-4">Artikel Makna by GERY</h1>
                        {articles.map((article,idx)=>(
                            <div className="col mt-4" key={idx} hoba={idx}>
                                <div className="card mb-4">
                                    {/* <h5 className="card-header">Featured</h5> */}
                                        <div className="card-body">
                                            <div className="row mb-4">
                                                <div className="col-3">
                                                    <img 
                                                        style={{width:'100%'}}
                                                        src={ articles[idx].media.medium }
                                                        alt={articles[idx].title}
                                                    />
                                                </div>
                                                <div className="col-9">
                                                    <h5 className="card-title">{articles[idx].title}</h5>
                                                    <p className="card-text">{this.setDateDisplay(articles[idx].date)} by {articles[idx].acf.publisher}</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <p className="card-text" dangerouslySetInnerHTML={{__html: articles[idx].acf.teaser}}></p>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col">
                                                    <Link to={{
                                                        pathname:'/article/'+articles[idx].id,
                                                        state: { datas: articles[idx], allDatas:articles }
                                                    }}>
                                                        Read Review
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </DocumentMeta>
            )
        }
        return <h3>Loading...</h3>;
    }
}

articles.propTypes = {
    fetchArticles:PropTypes.func.isRequired,
    articles:PropTypes.array.isRequired 
}

const mapStateToProps = state => ({
    articles:state.articles.datas
})

export default connect(mapStateToProps,{fetchArticles})(articles);
